import React, { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "config/store";
import NavBar from "components/layouts/NavBar.tsx";
import AuthModals from "components/modals/automatics/AuthModals.tsx";
import { UserType } from "globals/types/models.ts";
import WelcomeAutomaticModal from "components/modals/automatics/WelcomeAutomaticModal.tsx";
import MobileAppInstallBanner from "components/modals/automatics/MobileAppInstallBanner.tsx";
import { useMount } from "react-use";
import { searchActions } from "config/store/modules/search.ts";

type PropsType = {
  name: string
  needAuth?: boolean
  needAdmin?: boolean
  hideNavBar?: boolean
  component: React.ReactNode | (() => React.ReactElement) | ((props: {
    name: string
  }) => void) | ((props: {
    name: string
  }) => void);
}

function PageWrapper(props: PropsType) {
  const { name, needAuth = false, needAdmin = false, hideNavBar = false, component: Component } = props;

  const dispatch = useAppDispatch();
  const currentUser: UserType | null = useAppSelector(state => state.auth.user);
  const navigate = useNavigate();
  //make sure we dont render the component before check for needAuth, so we don't get error inside the component
  const [isCheck, setCheck] = useState<boolean>(false);


  useMount(() => {
    dispatch(searchActions.featuredEvents());
  });

  //body class
  useEffect(() => {
    document.body.classList.add(`p-${name}`);
    return () => {
      document.body.classList.remove(`p-${name}`);
    };
  }, [name]);

  //make sure route that need user have it
  useEffect(() => {
    if (!currentUser && needAuth) {
      navigate({ pathname: "/map", hash: "#/auth/login" }, { replace: true });
    }

    if (currentUser && needAdmin && !currentUser.isAdmin) {
      navigate({ pathname: "/map", hash: "#/auth/login" }, { replace: true });
    }

    setCheck(true);
    return () => {
      setCheck(false);//reset
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, needAuth, needAdmin]);

  if (!isCheck) {
    return null;
  }

  //@ts-ignore
  return (
    <Suspense>
      {/* @ts-ignore*/}
      <Component name={props.name} />
      {!hideNavBar && <NavBar />}
      <AuthModals />
      <WelcomeAutomaticModal />
      <MobileAppInstallBanner />
    </Suspense>
  );

}

export default PageWrapper;
